import React, { useEffect, useState } from 'react';
import { Page } from '@/payload/payload-types';
import RichTextLexical from '../../_components/RichTextLexical';
import { Button } from '../../_components/Button';

type TabbedContentType = Extract<Page['layoutBlocks'][0], { blockType: 'tabbedContent' }>;
type TabbedContentProps = Omit<TabbedContentType, 'blockType'>;

export const TabbedContent: React.FC<TabbedContentProps> = ({ tabs }) => {
	const [selectedTab, setSelectedTab] = useState<TabbedContentProps['tabs'][number] | null>(null);

	useEffect(() => {
		if (tabs && tabs.length > 0) {
			setSelectedTab(tabs[0]);
		}
	}, [tabs]);

	return (
		<>
			<div className="mb-12 flex space-x-1">
				{tabs.map(tab => (
					<Button
						size="small"
						intent="secondary"
						variant={`${selectedTab && tab.title === selectedTab.title ? 'solid' : 'outlined'}`}
						className={`${selectedTab && tab.title === selectedTab.title ? 'border-gold-light border' : ''}`}
						key={tab.title}
						onClick={() => setSelectedTab(tab)}
					>
						{tab.title}
					</Button>
				))}
			</div>
			{selectedTab && selectedTab.content && (
				<RichTextLexical content={selectedTab.content} />
			)}
		</>
	);
};
